module.exports = __webpack_public_path__ + "static/media/hydralight.db2d306b.jpg";